"use client";

import { c as _c } from "react/compiler-runtime";
import { useWorkflowRunsStore } from "@/stores/workflowRunsStore";
import { useMemo } from "react";
import { useSearchParams } from "next/navigation";

/** Extract workflow ID from URL search params as fallback */
function useWorkflowIdFromUrl() {
  const $ = _c(2);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("id") ?? undefined;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
interface VersionCompareData {
  failedVersion: number | null;
  successVersion: number | null;
  canCompare: boolean;
  resolvedWorkflowId: string | undefined;
}

/**
 * Derives version compare data from the shared workflowRunsStore,
 * avoiding duplicate fetches when FailedRunBanner already loaded runs.
 */
export function useVersionCompareData(workflowId, currentRunId) {
  const $ = _c(12);
  const urlWorkflowId = useWorkflowIdFromUrl();
  const resolvedWorkflowId = workflowId || urlWorkflowId;
  const storeRuns = useWorkflowRunsStore(_temp);
  let t0;
  let t1;
  if ($[0] !== resolvedWorkflowId || $[1] !== storeRuns) {
    t1 = resolvedWorkflowId ? storeRuns.filter(r => r.workflowId === resolvedWorkflowId) : storeRuns;
    $[0] = resolvedWorkflowId;
    $[1] = storeRuns;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const workflowRuns = t1;
  let failed;
  let t2;
  if ($[3] !== currentRunId || $[4] !== workflowRuns) {
    const sorted = [...workflowRuns].sort(_temp2);
    failed = currentRunId ? sorted.find(r_0 => r_0.id === currentRunId) : sorted.find(_temp3);
    t2 = sorted.find(_temp4);
    $[3] = currentRunId;
    $[4] = workflowRuns;
    $[5] = failed;
    $[6] = t2;
  } else {
    failed = $[5];
    t2 = $[6];
  }
  const success = t2;
  const failedVersion = failed?.workflowVersion ?? null;
  const successVersion = success?.workflowVersion ?? null;
  const canCompare = failedVersion != null && successVersion != null;
  let t3;
  if ($[7] !== canCompare || $[8] !== failedVersion || $[9] !== resolvedWorkflowId || $[10] !== successVersion) {
    t3 = {
      failedVersion,
      successVersion,
      canCompare,
      resolvedWorkflowId
    };
    $[7] = canCompare;
    $[8] = failedVersion;
    $[9] = resolvedWorkflowId;
    $[10] = successVersion;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  t0 = t3;
  return t0;
}
function _temp4(r_2) {
  return r_2.status === "success";
}
function _temp3(r_1) {
  return r_1.status === "failure";
}
function _temp2(a, b) {
  return new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime();
}
function _temp(s) {
  return s.runs;
}